import {
  BodyTextSStrong,
  BB,
  BBLight80,
  GRAY30,
  BBLight20,
  GRAY90,
  GRAY60,
  BBPALE,
  GRAY80,
} from 'global-styles';
import { HTMLAttributes, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

type CommonBadgeProps = {
  colorType: 'Fill' | 'Outline' | 'Disabled';
};

type Props = PropsWithChildren<CommonBadgeProps> &
  HTMLAttributes<HTMLSpanElement>;

export const CommonSmallBadge = ({ colorType, children, ...rest }: Props) => {
  return (
    <CommonSmallBadgeContainer {...rest} colorType={colorType}>
      <BodyTextSStrong>{children}</BodyTextSStrong>
    </CommonSmallBadgeContainer>
  );
};
const CommonSmallBadgeContainer = styled.span<CommonBadgeProps>`
  padding: 0 1.6rem;
  border-radius: 4px;
  min-height: 2.4rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  ${({ colorType }) =>
    colorType === 'Disabled' &&
    css`
      color: ${GRAY30};
      background: ${GRAY90};
      border: 1px solid ${GRAY90};
    `};
  ${({ colorType }) =>
    colorType === 'Fill' &&
    css`
      color: #fff;
      background: ${BB};
      border: 1px solid ${BB};
    `};
  ${({ colorType }) =>
    colorType === 'Outline' &&
    css`
      color: ${BBLight20};
      background: #fff;
      border: 1px solid ${BBLight80};
    `};
`;

export const EventTagBadge = styled(BodyTextSStrong)`
  width: fit-content;
  padding: 2px 8px;
  color: ${GRAY60};
  border-radius: 4px;
  border: 1px solid ${GRAY90};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PDFDownloadBadge = ({ colorType, children, ...rest }: Props) => {
  return (
    <PDFDownloadBadgeContainer {...rest} colorType={colorType}>
      <BodyTextSStrong>{children}</BodyTextSStrong>
    </PDFDownloadBadgeContainer>
  );
};

const PDFDownloadBadgeContainer = styled.button<CommonBadgeProps>`
  padding: 0 1.6rem;
  border-radius: 4px;
  min-height: 2.4rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  transition: 0.2s all;
  ${({ colorType }) =>
    colorType === 'Disabled' &&
    css`
      color: ${GRAY80};
      background: #fafbfd;
      border: 1px solid ${GRAY80};
      cursor: not-allowed;
    `};
  ${({ colorType }) =>
    colorType === 'Outline' &&
    css`
      cursor: pointer;
      color: #00428e;
      background: ${BBPALE};
      border: 1px solid ${BB};
      svg {
        transition: 0.2s all;
        path {
          fill: ${BB};
        }
      }
      &:hover {
        background: #00234a;
        color: #fff;

        svg {
          path {
            fill: #fff;
          }
        }
      }
    `};
`;